/*
 * Define few commonly used RegExs
 *
 */

const PARAM_VAL_SEPARATOR = ',';

function regExQueryParamKey(key){
    return new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
}
function regExQueryParamKeyPluck(key){
    return new RegExp('[?&]' + key + '(=([^&#]*)|&|#|$)');
}
function queryParamSep(uri){
    return -1 !== uri.indexOf('?') ? '&' : '?';
}

/**
 * Utility to work with query parameters in provided `uri`
 */
export default class Parameter {

    /**
     * Update Query parameter in provided string, usually `window.location.href`
     *
     * @static
     * @param {string} uri - target value to carry out replacement
     * @param {string} key - key whose value needs a replacement
     * @param {string} value - value to replace with
     * @returns
     * @memberof Parameter
     */
    static update(key, value, uri) {
        const queryParamKeyRegEx = regExQueryParamKey(key);
        if (uri.match(queryParamKeyRegEx)) {
            return uri.replace(queryParamKeyRegEx, '' !== value ?  '$1' + key + '=' + value + '$2'  : '');
        }

        return uri + ('' !== value ? queryParamSep(uri) + key + '=' + value : '');

    }

    /**
     * Get Query value of given parameter
     *
     * @static
     * @param {string} name - Parameter name
     * @param {string} uri - target string
     * @returns
     * @memberof Parameter
     */
    static get(key, uri) {
        key = key.replace(/[\]]/g, '\\$&');
        const queryParamKeyPluckRegEx = regExQueryParamKeyPluck(key);
        const results = queryParamKeyPluckRegEx.exec(uri);
        return results && results[2] ? decodeURIComponent(results[2].replace(/\+/g, '')) : '';
    }

    /**
     * Remove provided values from given string, usually `window.location.href`
     *
     * @static
     * @param {string} uri
     * @param {string} key
     * @param {Array} remValues
     * @returns
     * @memberof Parameter
     */
    static remove(key, remValues, uri){
        if(uri && remValues.length){
            const currParamValues = this.get(key, uri).split(PARAM_VAL_SEPARATOR);
            const facetsParamValsToUpdate  = currParamValues
                .filter(filterVal => !remValues.includes(filterVal));
            return this.update(key,
                facetsParamValsToUpdate.length ? facetsParamValsToUpdate.join(PARAM_VAL_SEPARATOR) : '',
                uri);
        }
        return this.update(key, '', uri);
    }

}



// WEBPACK FOOTER //
// /src/common/parameter.js